export default {
  v3SubmitErrBtnViewOrder: '注文を表示',
  v3SubmitErrBtnBackHome: 'ホームへ',
  v3SubmitErrBtnRetry: '再試行',
  v3SubmitErrBtnRelogin: '再ログイン',
  v3SubmitErrBtnSwitchPay: '支払い方法を切替',
  v3SubmitErrBtnReorder: '再注文',
  v3SubmitErrBtnSwitchServer: 'サーバー切替',
  v3SubmitErrBtnViewOrderStatus: '注文状況',
  v3SubmitErrBtnBackStore: 'ショップへ戻る',
  v3SubmitErrBtnGoUpdate: 'アップデート',
  v3SubmitErrBtnResubscribe: '再サブスク',
  v3SubmitErrTipUpdateApp: 'アプリストアで更新してください',
  v3SubmitErrTipRelogin: '再ログインしてください',

  v3SubmitErrMsg120009: '注文は処理されました。ゲーム内でバックパックを確認してください。',
  v3SubmitErrMsg120003: '商品情報に誤りがあります。再度選択してください。',
  v3SubmitErrMsg120016: '送信が頻繁すぎます。数秒待ってから再試行してください。',
  v3SubmitErrMsg120025: 'リクエストパラメータが異常です。再度ログインしてから再試行してください。',
  v3SubmitErrMsg121012: '決済チャネルが一時的に利用できません。別の方法をお試しください。',
  v3SubmitErrMsg120012: 'ネットワークが不安定です。接続を確認して再試行してください。',
  v3SubmitErrMsg120002: 'ゲームキャラクターが見つかりません。先にキャラクターを作成してください。',
  v3SubmitErrMsg121019: '注文情報に誤りがあります。再度注文してください。',
  v3SubmitErrMsg120024: '事前登録ギフトは既に受け取っています。再度の操作は不要です。',
  v3SubmitErrMsg120000: 'ログインの有効期限が切れています。再度ログインしてください。',
  v3SubmitErrMsg120014: '注文番号が無効です。再度注文してください。',
  v3SubmitErrMsg121001: 'ゲームへのチャージに失敗しました。しばらくしてから再試行するか、サポートへ連絡してください。',
  v3SubmitErrMsg120015: '決済金額が異常です。商品を再度選択してください。',
  v3SubmitErrMsg120001: 'サーバーが一致しません。正しいサーバーに切り替えてください。',
  v3SubmitErrMsg120020: '決済チャネルがエラーを返しました。別の方法をお試しください。',
  v3SubmitErrMsg120010: 'ゲームのチャージ機能は一時的に停止しています。しばらくしてから再度お試しください。',
  v3SubmitErrMsg120006: '金額の検証に失敗しました。再度選択してください。',
  v3SubmitErrMsg121010: 'サンドボックス環境でのチャージリクエストは無効です。正式版をご利用ください。',
  v3SubmitErrMsg120017: '注文番号が重複しています。既に支払いが済んでいないか確認してください。',
  v3SubmitErrMsg120022: '決済コールバックの検証に失敗しました。しばらくしてから再試行してください。',
  v3SubmitErrMsg121000: 'システムが混雑しています。しばらくしてから再度お試しください。',
  v3SubmitErrMsg120011: '商品IDに誤りがあります。再度選択してください。',
  v3SubmitErrMsg121015: '決済金額の検証に失敗しました。再度注文してください。',
  v3SubmitErrMsg120004: '現在、この決済チャネルは利用できません。別の方法をお選びください。',
  v3SubmitErrMsg120005: '決済チャネルはメンテナンス中です。別の方法をご利用ください。',
  v3SubmitErrMsg120007: 'プラットフォームIDが無効です。再度ログインしてください。',
  v3SubmitErrMsg120008: 'リクエストパラメータが不足しています。再度送信してください。',
  v3SubmitErrMsg120013: 'デベロッパー注文番号が無効です。再度注文してください。',
  v3SubmitErrMsg120018: '決済がリスクコントロールによりブロックされました。サポートに連絡して確認を受けてください。',
  v3SubmitErrMsg120019: 'パッケージ名の検証に失敗しました。公式版をご利用ください。',
  v3SubmitErrMsg120021: '商品IDの検証に失敗しました。再度選択してください。',
  v3SubmitErrMsg120023: '事前登録ギフトの付与に異常が発生しました。しばらくしてからご確認ください。',
  v3SubmitErrMsg120026: 'アカウントが存在しません。アカウントの状態を確認してください。',
  v3SubmitErrMsg120030: '商品の在庫が不足しています。別の商品をお選びください。',
  v3SubmitErrMsg120031: 'この商品の購入上限を超えています。数量を調整してください。',
  v3SubmitErrMsg120032: 'ゲームバージョンが古すぎます。最新バージョンをダウンロードしてください。',
  v3SubmitErrMsg120080: '代理決済がリスク制御により制限されています。ご自身の決済方法をご利用ください。',
  v3SubmitErrMsg120081: '代理決済がリスク制御により遅延しています。しばらくしてから結果をご確認ください。',
  v3SubmitErrMsg121002: '注文キャッシュが無効です。再度注文してください。',
  v3SubmitErrMsg121003: 'チャージ設定が見つかりません。サポートに連絡してください。',
  v3SubmitErrMsg121004: '拡張パラメータが不足しています。再度送信してください。',
  v3SubmitErrMsg121005: 'キャッシュの書き込みに失敗しました。しばらくしてから再試行してください。',
  v3SubmitErrMsg121006: 'キャッシュの読み取りに失敗しました。しばらくしてから再試行してください。',
  v3SubmitErrMsg121007: 'チャージタイプの設定に誤りがあります。サポートに連絡してください。',
  v3SubmitErrMsg121011: 'Appleチャネルで新しいフィールドが検出されました。アプリを更新してください。',
  v3SubmitErrMsg121013: '継続注文が見つかりません。再度サブスクリプションを行ってください。',
  v3SubmitErrMsg121014: 'チャージパラメータの復号に失敗しました。再度送信してください。',
  v3SubmitErrMsg121017: 'この注文は返金済みです。サポートに連絡して確認を受けてください。',
  v3SubmitErrMsg121018: 'サブスクリプションの有効期限が切れています。再度サブスクライブしてください。',
  v3SubmitErrMsg121020: '注文はキャンセルされました。再度注文してください。',
  v3SubmitErrMsg121021: 'Google APIでエラーが発生しました。しばらくしてから再試行してください。',
  v3SubmitErrMsg121022: 'アクセストークンの取得に失敗しました。再度ログインしてください。',
  v3SubmitErrMsg121023: '注文ステータスが異常です。入金状況を確認してください。',
  v3SubmitErrMsg121024: '注文の確認に失敗しました。しばらくしてから再試行してください。'
};
